import { API_MEDIA_UPLOADS_PRIVATE } from './models';
import { api } from 'AurionCR/components';
import { fileToBase64 } from 'AurionCR/components/formV2/elements/field-fiels/utils';

export * from './models';

class Service {
  async getFile(url: string) {
    const result = await api.get<Blob>(API_MEDIA_UPLOADS_PRIVATE.GET_FILE({ filePath: url }), {
      responseType: 'blob',
    });

    if (result.status === 204) {
      throw new Error('content-was-not-found');
    }

    const base64 = await fileToBase64(result.data);
    return { data: base64 };
  }
}
export const ServiceMediaUploadsPrivate = new Service();
